import { render } from "./merging.vue?vue&type=template&id=5b3f2a7e"
import script from "./merging.vue?vue&type=script&lang=js"
export * from "./merging.vue?vue&type=script&lang=js"

import "./merging.vue?vue&type=style&index=0&id=5b3f2a7e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__